module.exports = __webpack_public_path__ + "static/media/student-summary-50p.aa534bfb.png";